/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pesticide_Disease_Onset_TimeInputs */

const vi_pesticide_disease_onset_time = /** @type {(inputs: Pesticide_Disease_Onset_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời gian gây bệnh`)
};

/**

* @param {Pesticide_Disease_Onset_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pesticide_disease_onset_time = /** @type {((inputs?: Pesticide_Disease_Onset_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pesticide_Disease_Onset_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pesticide_disease_onset_time(inputs)
});